// extracted by mini-css-extract-plugin
module.exports = {"container":"DebugStyles_container__1rW5x","btn":"DebugStyles_btn__2JHj5"};